import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

const styles = require('./OptionsPaneLoading.scss');

export default class OptionsPaneLoading extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.messageContainer}>
                <div>
                    <Spinner type={SpinnerType.large} />
                </div>
                <div className={styles.messageText}>{strings.optionsFull_subCategory_loading}</div>
            </div>
        );
    }
}
